module.exports = __webpack_public_path__ + "img/glasses-round.8743cae4.svg";